import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { ICS_CONVERSATION_REDUCER_TOKEN, icsConversationReducerProvider, rootReducerKey } from './conversation.reducer';
import { EffectsModule } from '@ngrx/effects';
import { IcsConversationEffects } from './conversation.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(rootReducerKey, ICS_CONVERSATION_REDUCER_TOKEN),
    EffectsModule.forFeature([IcsConversationEffects])
  ],
  providers: [
    icsConversationReducerProvider
  ]
})
export class IcsConversationStoreModule { }
